export const LICENSE_MANAGEMENT = 'license-management'
export const USER_MANAGEMENT = 'user-management'
